import { crewMemberInfoText } from '../text';
import { formatHoursTracking, isUsedHoursLessThanOne } from '../utils/hoursTracking';

/**
 * @typedef {Object} HoursTrackingRow
 * @property {string} key       Stable React key + testid segment.
 * @property {string} label     User-visible row label.
 * @property {string} value     Preformatted "used / limit" string.
 * @property {boolean} isWarning `true` when the remaining balance is < 1 hour.
 */

/**
 * Build a fixed-order (driving → duty → 8-day) list of row descriptors for
 * the hours-tracking table. Each row carries a preformatted `value` and a
 * `isWarning` boolean so the JSX layer stays presentation-only.
 *
 * @param {import('./deriveClassification').HoursTracking} hoursTracking
 * @returns {HoursTrackingRow[]}
 */
export const buildHoursTrackingRows = (hoursTracking) => [
	{
		key: 'driving',
		label: crewMemberInfoText.drivingBalance,
		value: formatHoursTracking(
			hoursTracking.drivingMinutesBalance,
			hoursTracking.drivingMinutesLimit
		),
		isWarning: isUsedHoursLessThanOne(
			hoursTracking.drivingMinutesBalance,
			hoursTracking.drivingMinutesLimit
		),
	},
	{
		key: 'duty',
		label: crewMemberInfoText.dutyBalance,
		value: formatHoursTracking(hoursTracking.dutyMinutesBalance, hoursTracking.dutyMinutesLimit),
		isWarning: isUsedHoursLessThanOne(
			hoursTracking.dutyMinutesBalance,
			hoursTracking.dutyMinutesLimit
		),
	},
	{
		key: 'eightDay',
		label: crewMemberInfoText.eightDayDuty,
		value: formatHoursTracking(
			hoursTracking.eightDaysDutyMinutesBalance,
			hoursTracking.eightDaysDutyMinutesLimit
		),
		isWarning: isUsedHoursLessThanOne(
			hoursTracking.eightDaysDutyMinutesBalance,
			hoursTracking.eightDaysDutyMinutesLimit
		),
	},
];
